__turbopack_context__.v({
  "aspectRatio__inner": "HeroSliderBlok-module__u4OOtq__aspectRatio__inner",
  "aspectRatio__outer": "HeroSliderBlok-module__u4OOtq__aspectRatio__outer",
  "blok-big-title": "HeroSliderBlok-module__u4OOtq__blok-big-title",
  "blok-subtitle": "HeroSliderBlok-module__u4OOtq__blok-subtitle",
  "blok-title": "HeroSliderBlok-module__u4OOtq__blok-title",
  "dot": "HeroSliderBlok-module__u4OOtq__dot",
  "dot-button": "HeroSliderBlok-module__u4OOtq__dot-button",
  "dot__gallery": "HeroSliderBlok-module__u4OOtq__dot__gallery",
  "embla": "HeroSliderBlok-module__u4OOtq__embla",
  "embla__container": "HeroSliderBlok-module__u4OOtq__embla__container",
  "embla__slide": "HeroSliderBlok-module__u4OOtq__embla__slide",
  "is-selected": "HeroSliderBlok-module__u4OOtq__is-selected",
  "root": "HeroSliderBlok-module__u4OOtq__root",
});
